import en from "./Locales/en.json";

export const LanguageSettings = {
    languages: {
        en: { translation: en }
    },
    availableLanguages: ["en"]
};

export default LanguageSettings;